// True when the shift's scheduled end has already passed in UK time.
// Handles overnight shifts (end_time <= start_time → ends the NEXT day).
export function isShiftEndPassedUK(shift) {
  if (!shift?.end_time || !shift?.date || !shift?.start_time) return false;
  try {
    const fmt = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/London',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false,
    });
    const parts = fmt.formatToParts(new Date());
    const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));
    const nowDate = `${map.year}-${map.month}-${map.day}`;
    const nowTime = `${map.hour}:${map.minute}`;
    const overnight = shift.end_time <= shift.start_time;
    if (overnight) {
      const d = new Date(`${shift.date}T00:00:00Z`);
      d.setUTCDate(d.getUTCDate() + 1);
      const nextDate = d.toISOString().slice(0, 10);
      if (nowDate > nextDate) return true;
      if (nowDate === nextDate && nowTime >= shift.end_time) return true;
      return false;
    }
    if (nowDate > shift.date) return true;
    if (nowDate === shift.date && nowTime >= shift.end_time) return true;
    return false;
  } catch {
    return false;
  }
}
